import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlatformAnnouncesComponent } from './platform-announces.component';
import { AddPlatformAnnouncesComponent } from './add-platform-announces/add-platform-announces.component';
import { EditPlatformAnnouncesComponent } from './edit-platform-announces/edit-platform-announces.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';

@NgModule({
  declarations: [
    PlatformAnnouncesComponent, 
    AddPlatformAnnouncesComponent, 
    EditPlatformAnnouncesComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
		FormsModule,
		MaterialModule,
  ],
  exports: [PlatformAnnouncesComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PlatformAnnouncesModule {}
